import {
  AppBar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Theme,
  Toolbar,
  Typography
} from '@material-ui/core';
import { Launch } from '@material-ui/icons';
import { useObserver } from 'mobx-react-lite';
import React, { FC, Fragment } from 'react';
import { useNavigation } from 'react-navi';
import { isNumber } from 'util';
import { useKiosks } from '../../stores/KiosksStore';
import ViewStateContainer from '../Core/ViewStateContainer/ViewStateContainer';

const useStyles = makeStyles((theme: Theme) => {
  const tbHeight = isNumber(theme.mixins.toolbar.minHeight)
    ? theme.mixins.toolbar.minHeight
    : 0;
  return {
    content: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      overflowY: 'auto',
      overflowX: 'hidden',
      height: `calc(100% - ${tbHeight + theme.spacing(4)}px)`
    }
  };
});

const KiosksPage: FC<{}> = () => {
  const classes = useStyles();
  const kiosksStore = useKiosks();
  const navigation = useNavigation();

  const handleSelect = (kioskid: string) =>
    navigation.navigate(`/store/${kiosksStore.storeid}/kiosk/${kioskid}`);

  return useObserver(() => (
    <Fragment>
      <AppBar key="appbar" position="sticky">
        <Toolbar>
          <Typography variant="h6">
            Please select kiosk to begin ordering
          </Typography>
        </Toolbar>
      </AppBar>
      <Box key="content" className={classes.content}>
        <ViewStateContainer
          state={kiosksStore.viewState}
          onReload={() => kiosksStore.reload()}
        >
          <List>
            {kiosksStore.kiosks.map(kiosk => [
              <ListItem
                key={kiosk.id}
                onClick={() => handleSelect(kiosk.id)}
                button
              >
                <ListItemText primary={kiosk.name} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="open screen">
                    <Launch />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>,
              <Divider key={`${kiosk.id}Divider`} component="li" />
            ])}
          </List>
        </ViewStateContainer>
      </Box>
    </Fragment>
  ));
};

export default KiosksPage;
